var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvasGrafica",attrs:{"id":`grafica-${_vm.dia}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }